import { cookieManager } from "@/service/cookieManager";

const state = {
	elaborationStationViewOptions: {
		showChoices: false,
		orderNewestFirst: false,
		isFormatedTicket: false,
		showProductsUngrouped: false,
		showGhostProductOrders: true,
		showGhostOrdersProductOrders: false,
	},
};

const getters = {
	elaborationStationViewOptions(state) {
		return state.elaborationStationViewOptions;
	},
	showChoices(state) {
		return state.elaborationStationViewOptions.showChoices;
	},
	orderNewestFirst(state) {
		return state.elaborationStationViewOptions.orderNewestFirst;
	},
	isFormatedTicket(state) {
		return state.elaborationStationViewOptions.isFormatedTicket;
	},
	showProductsUngrouped(state) {
		return state.elaborationStationViewOptions.showProductsUngrouped;
	},
	showGhostProductOrders(state) {
		return state.elaborationStationViewOptions.showGhostProductOrders;
	},
	showGhostOrdersProductOrders(state) {
		return state.elaborationStationViewOptions.showGhostOrdersProductOrders;
	},
};

const mutations = {
	setShowChoices(state, value) {
		state.elaborationStationViewOptions.showChoices = value;
	},
	setOrderNewestFirst(state, value) {
		state.elaborationStationViewOptions.orderNewestFirst = value;
	},
	setIsFormatedTicket(state, value) {
		state.elaborationStationViewOptions.isFormatedTicket = value;
	},
	setShowProductsUngrouped(state, value) {
		state.elaborationStationViewOptions.showProductsUngrouped = value;
	},
	setShowGhostProductOrders(state, value) {
		state.elaborationStationViewOptions.showGhostProductOrders = value;
	},
	setShowGhostOrdersProductOrders(state, value) {
		state.elaborationStationViewOptions.showGhostOrdersProductOrders = value;
	},
};

const actions = {
	updateShowChoices({ commit, dispatch }, value) {
		commit("setShowChoices", value);
		dispatch("saveViewOptionsToCookie");
	},
	updateOrderNewestFirst({ commit, dispatch }, value) {
		commit("setOrderNewestFirst", value);
		dispatch("saveViewOptionsToCookie");
	},
	updateIsFormatedTicket({ commit, dispatch }, value) {
		commit("setIsFormatedTicket", value);
		dispatch("saveViewOptionsToCookie");
	},
	updateShowProductsUngrouped({ commit, dispatch }, value) {
		commit("setShowProductsUngrouped", value);
		dispatch("saveViewOptionsToCookie");
	},
	updateShowGhostProductOrders({ commit, dispatch }, value) {
		commit("setShowGhostProductOrders", value);
		dispatch("saveViewOptionsToCookie");
	},
	updateShowGhostOrdersProductOrders({ commit, dispatch }, value) {
		commit("setShowGhostOrdersProductOrders", value);
		dispatch("saveViewOptionsToCookie");
	},
	initializeViewOptionsFromCookie({ commit }) {
		const cookie = cookieManager.getCookie("elaborationStationViewOptions");
		if (!cookie) return;

		try {
			const options = JSON.parse(cookie);
			if (typeof options === "object") {
				if ("showChoices" in options) commit("setShowChoices", options.showChoices);
				if ("orderNewestFirst" in options) commit("setOrderNewestFirst", options.orderNewestFirst);
				if ("isFormatedTicket" in options) commit("setIsFormatedTicket", options.isFormatedTicket);
				if ("showProductsUngrouped" in options) commit("setShowProductsUngrouped", options.showProductsUngrouped);
				if ("isIntern" in options) commit("setIsIntern", options.isIntern);
				if ("showGhostProductOrders" in options) {
					commit("setShowGhostProductOrders", options.showGhostProductOrders);
				}
				if ("showGhostOrdersProductOrders" in options) {
					commit("setShowGhostOrdersProductOrders", options.showGhostOrdersProductOrders);
				}
			}
		} catch (err) {
			console.warn("Cookie malformada: elaborationStationViewOptions", err);
		}
	},
	saveViewOptionsToCookie({ state }) {
		cookieManager.setCookie("elaborationStationViewOptions", JSON.stringify(state.elaborationStationViewOptions));
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
